export default function EquipmentRouteConfig($stateProvider, gettext) {
  'ngInject';

  $stateProvider
    .state('equipment', {
      url: '/assets',
      helpModuleId: 'assets',
      helpState: 'assets',
      template: require('./equipment.main.html'),
      controller: 'EquipmentController',
      redirectTo: 'equipment.list',
      ncyBreadcrumb: {
        label: "{{'Asset' | translate}}",
        skip: true,
      },
      requiredFeatures: ['assets'],
    })
    .state('equipment.list', {
      url: '/?q=&filters&tags&maintenance&alerts&securityGroups&{page:int}&{limit:int}',
      helpModuleId: 'assets',
      helpState: 'assets.list',
      template: require('./list/list.html'),
      controller: 'EquipmentListController as vm',
      reloadOnSearch: false,
      ncyBreadcrumb: {
        label: "{{'Assets' | translate}}",
      },
      requiredFeatures: ['assets'],
      data: {
        flex: true,
      },
    })
    .state('equipment.edit', {
      url: '/edit',
      helpModuleId: 'assets',
      helpState: 'assets.list',
      template: '<b-equipment-update></b-equipment-update>',
      ncyBreadcrumb: {
        label: "{{'Edit' | translate}}",
        parent: 'equipment.list',
      },
      requiredFeatures: ['assets', 'assets.edit.bulk', 'assets.update-trial'],
      data: {
        flex: true,
        breadcrumb: true,
      },
    })
    .state('equipment.esn', {
      url: '/esn/:serialNumber',
      template: require('./esn/esn.html'),
      controller: 'ESNController',
      controllerAs: 'vm',
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail', {
      url: '/detail/:equipmentId',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      template: require('./asset-details-dashboard/asset-details-dashboard.component.html'),
      controller: 'AssetDetailsDashboardController',
      controllerAs: 'vm',
      redirectTo: 'equipment.detail.overview',
      params: {
        title: null,
      },
      data: {
        flex: true,
        breadcrumb: true,
      },
      ncyBreadcrumb: {
        parent: 'equipment.list',
        label: '{{assetName || vm.equipmentData.name}}',
        // here twice because of scope issues, details isn't a component and edit is
        // ToDo: remove first variable when details is changed to a component
      },
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail-edit', {
      url: '/detail/:equipmentId/edit',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      template: '<equipment-detail-edit></equipment-detail-edit>',
      ncyBreadcrumb: {
        parent: 'equipment.detail',
        label: "{{'Edit' | translate}}",
      },
      params: {
        title: null,
      },
      data: {
        flex: true,
        breadcrumb: true,
      },
      requiredFeatures: ['assets', 'assets.edit'],
    })
    .state('equipment.detail.overview', {
      url: '/overview',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      template:
        '<asset-data-overview loading="vm.loading" refreshing="vm.refreshing" asset="vm.asset" date-range="vm.dataDateRange" series-data-status="vm.seriesDataStatus" selected-series-ids="vm.selectedSeriesIds" active-tab="vm.activeDataTap" series-data="vm.seriesData"></asset-data-overview>',
      data: {
        dateRange: {
          start: null,
          end: null,
        },
        asset: {
          id: null,
          displayCharts: [],
        },
      },
      ncyBreadcrumb: {
        parent: 'equipment.detail',
        skip: true,
      },
      reloadOnSearch: false,
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail.details', {
      url: '/details',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      template:
        '<asset-details-section  asset="vm.asset" loading="vm.detailsLoading"></asset-details-section>',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail.location', {
      url: '/location',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      template:
        '<asset-location asset="vm.asset" location-series="vm.asset.locationSeries" refreshing="vm.refreshing" ></asset-location>',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail.alerts', {
      template:
        '<asset-alerts loading="vm.loading" refreshing="vm.refreshing" asset="vm.asset" ></asset-alerts>',
      helpModuleId: 'assets',
      helpState: 'assets.detail',
      url: '/alerts',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['assets'],
    })
    .state('equipment.detail.devicecommands', {
      url: '/devicecommands',
      template: '<command-component></command-component>',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['commands'],
    })
    .state('equipment.detail.maintenance', {
      template:
        '<asset-maintenance loading="vm.loading" refreshing="vm.refreshing" asset="vm.asset" ></asset-maintenance>',
      url: '/maintenance',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['assets', 'maintenance'],
    })
    .state('equipment.detail.deviceDiagnostics', {
      template:
        '<asset-device-diagnostics  asset="vm.asset" refreshing="vm.refreshing"></asset-device-diagnostics>',
      url: '/deviceDiagnostics',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['assets.diagnostics'],
    });
}
